module.exports = __webpack_public_path__ + "img/img_50_default_profile@3x.4ff70059.png";